import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../config/themeTokens';
import { Text } from '../primitives';

const Card = styled.blockquote`
  padding: ${tokens.spacing.lg};
  border-radius: ${tokens.radius.md};
  background: ${tokens.colors.background};
  border-left: 4px solid ${tokens.colors.primary};
`;

const Cite = styled.cite`
  display: block;
  margin-top: ${tokens.spacing.md};
  font-size: ${tokens.typography.sizeSm};
  color: ${tokens.colors.textMuted};
  font-style: normal;
`;

export function TestimonialCard({ quote, author, ...props }) {
  return (
    <Card {...props}>
      <Text as="p" style={{ margin: 0 }}>
        {quote}
      </Text>
      {author && <Cite>— {author}</Cite>}
    </Card>
  );
}

export default TestimonialCard;
